import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, ProjectService,} from '../../_services/index';

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import {LoginHelper} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {IndexConfigService} from "../../_services/index.config.service";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "cloneProject-component",
  templateUrl: 'cloneProject.component.html',
  styleUrls: ['./cloneProject.component.scss'],
})

export class CloneProjectComponent implements OnInit {
  api = window.location.origin;
  projects: any[];
  constructor(
    public config: IndexConfigService,
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public projectService: ProjectService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,) {
  }

  ngOnInit() {
    let tenantName = LoginHelper.getTenantName();
    this.projectService.getClonedStatus(tenantName).subscribe(p => this.projects = p);
  }
}
